var map = {
	"./educational-content-dashboard.png": 2241,
	"./hand-dashboard.png": 39199,
	"./head-dashboard.png": 20382,
	"./notification-dashboard.png": 45477,
	"./schedules-dashboard.png": 48662,
	"./what-goes-where-dashboard.png": 69871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2113;